import React from 'react';
import { Typography } from '@material-ui/core';
import { Container } from 'react-bootstrap';

import './privacy-policy.scss';

export default function Support(props) {

    return (
        <div>
            <Container>
                <Typography variant="h3" align="center">Essentiel Foot</Typography>
                <Typography variant="h5" align="center">Support</Typography>
            </Container>

            <div id="message">
                <h2>Support</h2>
                <p><strong>Contactez-nous</strong></p>
                <p>
                    Si vous avez des questions ou des suggestions concernant essentielFoot contactez-nous à l'adresse
                    fordine.dev@gmail.com.
        </p>
            </div>
        </div>
    )
}